<template>
    <div
        class="l-ss-c-popup"
        :class="{ 'l-ss-c-popup-opened': opened }">
        <div class="l-ss-c-popup-inner">
            <button
                class="l-ss-c-button l-ss-c-button-plain l-ss-c-popup-close"
                @click="() => $emit('close')">
                <i
                    :class="{ 'l-ss-c-popup-icon-mounted': isMounted }"
                    v-html="iconClosePopup"></i>
            </button>
            <h2
                class="l-ss-c-popup-title"
                v-if="title">
                {{ title }}&nbsp;
            </h2>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import iconClosePopup from '../assets/images/icons/close-popup.svg';

    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            opened: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isMounted: false,
            };
        },
        computed: {
            iconClosePopup() {
                return iconClosePopup;
            },
        },
        mounted() {
            this.isMounted = true;
        },
    };
</script>